/* src/app/components/lead-details/employer/employer/employer.component.css */
/*# sourceMappingURL=employer.component-BDQL4Y5S.css.map */
